import React from 'react';
import useFadeIn from './useFadeIn';

const reviews = [
  {
    text: 'Samochód prezentował się obłędnie. Goście byli zachwyceni i wszyscy pytali, czyje to auto. Najlepszy wybór, jaki mogliśmy zrobić.',
    author: 'Karolina i Marek',
    role: 'Para Młoda, wrzesień 2024',
    initials: 'KM',
  },
  {
    text: 'Piękne wnętrze i profesjonalna obsługa. Wszystko było dopięte na ostatni guzik, nic nie zakłóciło naszego wielkiego dnia. Polecamy z pełnym przekonaniem.',
    author: 'Agnieszka Wiśniewska',
    role: 'Para Młoda, czerwiec 2024',
    initials: 'AW',
  },
  {
    text: 'Auto wyglądało jeszcze lepiej niż na zdjęciach. Fotograf był zachwycony — mamy niesamowite zdjęcia. Jasne wnętrze to strzał w dziesiątkę.',
    author: 'Tomasz i Julia',
    role: 'Para Młoda, sierpień 2024',
    initials: 'TJ',
  },
];

function Stars() {
  return (
    <div style={{ display: 'flex', gap: 4, marginBottom: 20 }}>
      {[...Array(5)].map((_, i) => (
        <svg key={i} width="16" height="16" viewBox="0 0 24 24" fill="#f59e0b" stroke="none">
          <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
        </svg>
      ))}
    </div>
  );
}

export default function Reviews() {
  const titleRef = useFadeIn();

  return (
    <section
      id="reviews"
      style={{
        padding: '120px 24px',
        background: 'linear-gradient(180deg, #050a1a 0%, #0a1628 100%)',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      <div
        aria-hidden="true"
        style={{
          position: 'absolute',
          width: 500,
          height: 500,
          borderRadius: '50%',
          background: 'radial-gradient(circle, rgba(59,130,246,0.07) 0%, transparent 70%)',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          pointerEvents: 'none',
        }}
      />

      <div style={{ maxWidth: 1280, margin: '0 auto', position: 'relative', zIndex: 1 }}>
        <div ref={titleRef} className="fade-in-section" style={{ textAlign: 'center', marginBottom: 72 }}>
          <p className="section-label" style={{ marginBottom: 16 }}>Opinie klientów</p>
          <h2 className="section-title">
            Co mówią{' '}
            <span
              style={{
                fontStyle: 'italic',
                background: 'linear-gradient(135deg, #3b82f6, #60a5fa)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text',
              }}
            >
              nasi klienci
            </span>
          </h2>
        </div>

        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
            gap: 24,
          }}
        >
          {reviews.map((r, i) => (
            <ReviewCard key={i} {...r} delay={i * 100} />
          ))}
        </div>
      </div>
    </section>
  );
}

function ReviewCard({ text, author, role, initials, delay }) {
  const ref = useFadeIn();

  return (
    <div
      ref={ref}
      className="fade-in-section glass-card"
      style={{
        padding: '36px 32px',
        transition: 'all 0.35s ease',
        cursor: 'default',
        transitionDelay: `${delay}ms`,
        position: 'relative',
        overflow: 'hidden',
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.borderColor = 'rgba(59,130,246,0.3)';
        e.currentTarget.style.transform = 'translateY(-6px)';
        e.currentTarget.style.boxShadow = '0 24px 60px rgba(0,0,0,0.4), 0 0 40px rgba(59,130,246,0.06)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.borderColor = 'rgba(59,130,246,0.15)';
        e.currentTarget.style.transform = 'translateY(0)';
        e.currentTarget.style.boxShadow = 'none';
      }}
    >
      {/* Quote mark decoration */}
      <div
        aria-hidden="true"
        style={{
          position: 'absolute',
          top: 16,
          right: 24,
          fontSize: 80,
          fontFamily: '"Playfair Display", serif',
          color: 'rgba(59,130,246,0.08)',
          lineHeight: 1,
          userSelect: 'none',
        }}
      >
        "
      </div>

      <Stars />

      <blockquote
        style={{
          fontSize: 15,
          lineHeight: 1.75,
          color: 'rgba(244,245,247,0.75)',
          marginBottom: 28,
          fontStyle: 'italic',
          position: 'relative',
        }}
      >
        „{text}"
      </blockquote>

      <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
        <div
          style={{
            width: 44,
            height: 44,
            borderRadius: '50%',
            background: 'linear-gradient(135deg, #1a3460, #3b82f6)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: 13,
            fontWeight: 700,
            color: '#f4f5f7',
            flexShrink: 0,
          }}
        >
          {initials}
        </div>
        <div>
          <div style={{ fontSize: 14, fontWeight: 600, color: '#f4f5f7' }}>{author}</div>
          <div style={{ fontSize: 12, color: 'rgba(244,245,247,0.4)', marginTop: 2 }}>{role}</div>
        </div>
      </div>
    </div>
  );
}
